<script setup>
import {ref, computed, watch} from 'vue'
import {useRouter} from 'vue-router'
import Button from "@/common/Button.vue"
import {useThemesStore} from '@/stores/themes'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    index: {
        type: Number,
        required: true
    },
    editor: {
        type: Object,
        required: true
    }
})

const router = useRouter()
const themesStore = useThemesStore()
const itemDataStore = useItemDataStore()

// --- State ---

const item = ref(null)

// --- Computed ---

const activeEditorKey = computed(() => themesStore.activeEditorKey)

const typeColourClass = computed(() => {
    const classNames = {
        'templates_templates': '',
        'themes_javascript': 'text-danger',
        'themes_css': 'text-success',
    }
    return classNames[props.editor.tableName] || ''
})

watch(() => [props.editor.tableName, props.editor.id], async () => {
    item.value = await itemDataStore.get({
        tableName: props.editor.tableName,
        id: props.editor.id
    })
}, {immediate: true})

// --- Methods ---

const selectTab = () => {
    router.push({
        query: {
            section: props.editor.sectionName,
            id: props.editor.id
        }
    })
}

const removeEditor = () => {
    if (!props.editor.isModified || confirm('Are you sure?')) {
        themesStore.removeEditorByIndex({
            router: router,
            key: props.index
        })
    }
}
</script>

<template>
    <Button
        v-if="item"
        class="btn-sm me-1 p-1 d-flex align-items-center text-nowrap"
        @click.prevent="selectTab"
        :active-value="index === activeEditorKey"
        :active-class="'btn-primary'"
        :default-class="typeColourClass"
    >
        <i class="me-1 bi-x" @click.stop.prevent="removeEditor"></i>

        <small>{{ item.title }}</small>

        <span :class="{ 'bg-warning': editor.isModified }" class="rounded ps-1 pt-1 ms-2 me-1"/>
    </Button>
</template>

<style scoped>
/* Shows the 'X' (remove icon) only on hover */
button > :first-child {
    visibility: hidden;
}

button:hover > :first-child {
    visibility: visible;
}
</style>